import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import TopDisplayImage from "../TopDisplayImage"

export default function TopImage() {
  var data = useStaticQuery(graphql`
    query {
      topImg: file(relativePath: { eq: "site-planning-ponderosa.jpeg" }) {
        sharp: childImageSharp {
          fluid(quality: 85, maxWidth: 1200) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <TopDisplayImage
      sharpImage={data.topImg.sharp.fluid}
      alt="Landscaping Site Planning - Marin County and the surround areas. Ponderosa Ventures."
    />
  )
}
